module.exports = __webpack_public_path__ + "img/23.8161673d.jpg";